// extracted by mini-css-extract-plugin
export default {"container":"Monitor_container__mIaDA","rows":"Monitor_rows__4JCIA","boxes":"Monitor_boxes__OdUfO","attitude":"Monitor_attitude__m7srV"};